/// <amd-module name="Tfs/Frame/Components/Help/Help" />
import * as React from "react";
import { IUserSettingsMenu } from "Tfs/Frame/Components/Help/UserSettingsService";
import * as Resources from "Tfs/Frame/Resources";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { getMenuItems } from "VSS/Features/PlatformUI/ContributedMenu";
import { VssComponent } from "VSS/Platform/Layout";
import { ExpandableContainer, IExpandable } from "VSSUI/Expandable";
import { ContextualMenu } from "VSSUI/Menu";
import { Location } from "VSSUI/Utilities/Position";
import { ScreenSizeConditional } from "VSSUI/Utilities/ScreenSize";
import { MenuIcon } from "./MenuIcon";
import { Button } from "VSSUI/Button";

export class Help extends VssComponent<{}> {
    private expandableContainerRef: React.RefObject<ExpandableContainer> = React.createRef();
    private service = this.context.pageContext.getService<IUserSettingsMenu>("IUserSettingsMenu");

    public render(): JSX.Element {
        return (
            <ScreenSizeConditional condition={(screenSize) => screenSize > ScreenSize.xsmall}>
                <ExpandableContainer
                    ref={this.expandableContainerRef}
                    excludeFocusZone={true}
                    renderCallout={this.renderCallout}
                    role="menuitem"
                >
                    <Button
                        ariaLabel={Resources.Help}
                        className="icon-only"
                        subtle={true}
                        tooltipProps={{ text: Resources.Help }}
                    >
                        <MenuIcon
                            onComponentRendered={this.setHelpSettingsMenu} 
                            iconName={"Unknown"}
                        />
                    </Button>
                </ExpandableContainer>
            </ScreenSizeConditional>
        );
    }

    public setHelpSettingsMenu = (): void => {
        if (this.expandableContainerRef && this.expandableContainerRef.current) {
            this.service.setHelpMenu(this.expandableContainerRef.current.expand);
        }
    };

    private renderCallout = (dropdown: IExpandable, id: string, element: HTMLElement): JSX.Element => {
        return (
            <ContextualMenu
                onDismiss={dropdown.collapse}
                anchorElement={element}
                anchorOrigin={{ horizontal: Location.end, vertical: Location.end }}
                menuProps={{
                    id: "help-menu",
                    items: getMenuItems(this.context.pageContext, "ms.vss-tfs-web.help-menu")
                }}
                menuOrigin={{ horizontal: Location.end, vertical: Location.start }}
            />
        );
    };
}

VssComponent.register("ms.vss-tfs-web.help", Help);
